import { render, staticRenderFns } from "./admision.vue?vue&type=template&id=4459f1db&scoped=true"
import script from "./admision.vue?vue&type=script&lang=js"
export * from "./admision.vue?vue&type=script&lang=js"
import style0 from "./admision.vue?vue&type=style&index=0&id=4459f1db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4459f1db",
  null
  
)

export default component.exports